/* eslint-disable @typescript-eslint/no-throw-literal */
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { IMedicalNote, IFetchMedicalNotesOfSurgery } from '~/interfaces'
import { fetchMedicalNotesOfSurgery, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'medicalNotesOfSurgery'

export const useFetchMedicalNotesOfSurgery = (
  fetchParams: IFetchMedicalNotesOfSurgery | null,
  config?: UseQueryOptions<IMedicalNote[], Error, IMedicalNote[]>
): UseQueryResult<IMedicalNote[], Error> => {
  const hasFetchParams = hasObjectValue({ ...fetchParams })

  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchMedicalNotesOfSurgery(fetchParams)
      const isResponseEmpty = response.length <= 0

      if (isResponseEmpty) {
        throw message('detailsMedicalEvents.emptyMedicalNotesSurgeryRelated')
      }

      return response
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IMedicalNote[], Error>([UNIQUE_KEY, fetchParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    enabled: hasFetchParams,
    ...config
  })
}
